import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, interval, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiRootService } from '../apiroot.service';

@Injectable({
  providedIn: 'root'
})
export class OtpDialogService {
  private otpTimerDuration = 600; // seconds
  private otpRemainingTime = new BehaviorSubject<number>(0);
  private timerSubscription: Subscription | null = null;
  private isTimerRunning = false;

  constructor(private http: HttpClient, private service: ApiRootService) { }

  startTimer() {
    if (this.isTimerRunning) return;

    this.otpRemainingTime.next(this.otpTimerDuration);
    this.isTimerRunning = true;

    this.timerSubscription = interval(1000).subscribe(() => {
      const currentTime = this.otpRemainingTime.getValue();
      if (currentTime > 0) {
        this.otpRemainingTime.next(currentTime - 1);
      } else {
        this.clearOtpTimer();
      }
    });
  }

  resetTimer() {
    this.otpRemainingTime.next(this.otpTimerDuration);
  }

  clearOtpTimer() {
    // this.timerSubscription?.unsubscribe();
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }    
    this.timerSubscription = null;
    this.isTimerRunning = false;
    this.otpRemainingTime.next(0);
  }

  getOtpTimerObservable(): Observable<number> {
    return this.otpRemainingTime.asObservable();
  }

  getIsOtpActive(): boolean {
    return this.otpRemainingTime.getValue() > 0;
  }

  // public sendOtpToMaster(userId: number): Observable<any> {
  //   const url = `${this.service.AUTH}/api/email/otp/send?userId=${userId}`;
  //   return this.http.post<any>(url, {}); 
  // }

  public sendOtpToMaster(userId: number, vesselId: number): Observable<any> {
    const url = `${this.service.AUTH}/api/email/otp/send?vesselId=${vesselId}&userId=${userId}`;
    return this.http.post<any>(url, {}); 
  }
  

  public verifyOtpByMaster(otpRequest): Observable<any> {
    const url = `${this.service.AUTH}/api/email/otp/verify`;
    return this.http.post<any>(url, otpRequest);
  }
}
